module.exports = __webpack_public_path__ + "static/media/photoPlaceholder.61aa049b.jpg";